import React from 'react';
import { MonitorIcon, TabletSmartphoneIcon, SmartphoneIcon, PhoneIcon, MailIcon, SparklesIcon, UserRoundIcon, DatabaseIcon, ShieldCheckIcon, LinkIcon, UsersIcon, SettingsIcon, BarChart3Icon } from 'lucide-react';
import type { EntryKey, CoreKey, DestinationKey } from '../../data/platformOverview';
export const ENTRY_ICONS: Record<EntryKey, typeof MonitorIcon> = {
  web: MonitorIcon,
  portal: TabletSmartphoneIcon,
  mobile: SmartphoneIcon,
  phone: PhoneIcon,
  email: MailIcon,
  assistants: SparklesIcon
};
export const CORE_ICONS: Record<CoreKey, typeof MonitorIcon> = {
  identity: UserRoundIcon,
  record: DatabaseIcon,
  rules: ShieldCheckIcon,
  connectors: LinkIcon,
  atna: SparklesIcon
};
export const DEST_ICONS: Record<DestinationKey, typeof MonitorIcon> = {
  ops: UsersIcon,
  admin: SettingsIcon,
  decisions: BarChart3Icon
};

/* Tiny abstract UI fragments — decorative, not real data */
function TasksFragment() {
  return <div className="space-y-1" data-id="element-5585" data-mp="bpiiylzo1rb9">
      {[['bg-[#E8836E]', 72], ['bg-[#F0B24A]', 54], ['bg-[#4FB981]', 84]].map(([dot, w]) => <div key={String(w)} className="flex items-center gap-1.5 rounded bg-white border border-[#EEEDF6] px-1.5 py-1" data-id="element-5586" data-mp="22fwv59h18v4e">
          <span className={`w-1 h-1 rounded-full ${dot}`} data-id="element-5587" data-mp="1ybp2j17gev0w" />
          <span className="h-1 rounded-full bg-[#E4E3F2]" style={{
        width: `${w}%`
      }} data-id="element-5588" data-mp="1teoyswy2u4cy" />
        </div>)}
    </div>;
}
function ControlsFragment() {
  return <div className="space-y-1" data-id="element-5589" data-mp="1ogx6i1tisg88">
      {[true, true, false].map((on, i) => <div key={i} className="flex items-center justify-between rounded bg-white border border-[#EEEDF6] px-1.5 py-1" data-id="element-5590" data-mp="1jn1c19cgtbht" data-mpi={i}>
          <span className="h-1 rounded-full bg-[#E4E3F2]" style={{
        width: `${[56, 42, 64][i]}%`
      }} data-id="element-5591" data-mp="1emwt7co344of" />
          <span className={`w-4 h-2.5 rounded-full p-[2px] flex ${on ? 'bg-[#4F46E5] justify-end' : 'bg-[#DCDDE6] justify-start'}`} data-id="element-5592" data-mp="1alut6tmcfole">
            <span className="w-1.5 h-1.5 rounded-full bg-white" data-id="element-5593" data-mp="10p88c4u0oxjd" />
          </span>
        </div>)}
    </div>;
}
function ChartFragment() {
  return <div className="rounded bg-white border border-[#EEEDF6] px-1.5 pt-1.5 pb-1" data-id="element-5594" data-mp="r3ythty16ouu">
      <div className="flex items-end gap-[3px] h-[34px]" data-id="element-5595" data-mp="w2a5obbstbg8">
        {[36, 50, 42, 64, 56, 76, 92].map((h, i) => <span key={i} className={`flex-1 rounded-[1px] ${i === 6 ? 'bg-[#4F46E5]' : 'bg-[#D9D7F6]'}`} style={{
        height: `${h}%`
      }} data-id="element-5596" data-mp="h5ssrfnynork" data-mpi={i} />)}
      </div>
    </div>;
}
export const DEST_FRAGMENTS: Record<DestinationKey, () => JSX.Element> = {
  ops: TasksFragment,
  admin: ControlsFragment,
  decisions: ChartFragment
};